import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import Home from './pages';
import AboutMePage from './pages/aboutMe';
import CreditsPage from './pages/credits';
import ArticlesPage from './pages/articles';
import AssociationPage from './pages/association';
import LotusPage from './pages/lotus';
import GCSSPage from './pages/gcss';
import DiscoPage from './pages/disco';

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/about" component={AboutMePage} exact />
        <Route path="/credits" component={CreditsPage} exact />
        <Route path="/articles" component={ArticlesPage} exact />
        <Route path="/ABEII" component={AssociationPage} exact />
        <Route path="/Lotus" component={LotusPage} exact />
        <Route path="/Gcss" component={GCSSPage} exact />
        <Route path="/Disco" component={DiscoPage} exact />
      </Switch>
    </Router>
  );
}

export default App;
